// eslint-disable-next-line import/extensions
import SessionService from '_services/common/sessionService';
import Axios from 'axios';

const axiosHeader = () => {
  let token = SessionService.getLocalData('_token');
  token = (token) ? `Bearer ${token}` : token;
  Axios.defaults.headers.common.Authorization = token;
};

export default axiosHeader;
